import { Controller } from "@hotwired/stimulus"

// Confirms before marking a task done, since it's a one-click destructive-ish
// action with no undo in the UI yet.
export default class extends Controller {
  confirmComplete(event) {
    if (!window.confirm("Mark this task as done?")) {
      event.preventDefault()
    }
  }
}
